/**
 * AndVColumn - 柱状图组件
 * 基于 Ant Design Charts Column
 */
import React from 'react';
import { Column } from '@ant-design/plots';
import { parseBoolProp, withBaseChart } from '../base/BaseChart';
import type { AndVColumnProps } from '../base/types';

// 默认示例数据（设计器中展示）
const DEFAULT_COLUMN_DATA = [
  { category: '一月', value: 38 },
  { category: '二月', value: 52 },
  { category: '三月', value: 61 },
  { category: '四月', value: 45 },
  { category: '五月', value: 48 },
  { category: '六月', value: 58 },
];

// 使用 HOC 包装基础 Column 组件
const ColumnWithBase = withBaseChart<AndVColumnProps>(Column, {
  chartType: 'AndVColumn',
  defaultHeight: 300,
  defaultData: DEFAULT_COLUMN_DATA,
});

/**
 * AndVColumn 柱状图组件
 * 用于展示分类数据的对比，适用于不同类别之间的数值比较
 */
export const AndVColumn: React.FC<AndVColumnProps> = (props) => {
  const {
    xField = 'category',
    yField = 'value',
    seriesField,
    colorField,
    isGroup,
    isStack,
    group: groupProp,
    stack: stackProp,
    columnWidth,
    ...baseProps
  } = props;

  const resolvedGroup = groupProp !== undefined ? groupProp : isGroup;
  const resolvedStack = stackProp !== undefined ? stackProp : isStack;

  const chartProps: Record<string, any> = {
    ...baseProps,
    xField,
    yField,
  };

  if (seriesField) chartProps.seriesField = seriesField;
  if (colorField) chartProps.colorField = colorField;
  if (resolvedGroup !== undefined) {
    chartProps.group = parseBoolProp(resolvedGroup, false);
  }
  if (resolvedStack !== undefined) {
    chartProps.stack = parseBoolProp(resolvedStack, false);
  }
  if (columnWidth) chartProps.columnWidth = columnWidth;

  return <ColumnWithBase {...chartProps} />;
};

export type { AndVColumnProps };
export default AndVColumn;
